import { AudioPlayer } from "@pathwright/legacy-media-manager"
import { getAudioType } from "@pathwright/media-utils"
import { AudioViewWrapper } from "./ui"

const AudioView = (props) => {
  const { data, blockStyles } = props

  const { type, downloadURL, name, allowDownload } = data

  return (
    <AudioViewWrapper>
      <AudioPlayer
        src={downloadURL}
        trackTitle={name}
        allowDownload={allowDownload || false}
        customStyles={blockStyles}
        type={getAudioType(type)}
      />
    </AudioViewWrapper>
  )
}

export default AudioView
